// @ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import {
  EmarModuleCard,
  FamilyPlanModuleCard,
  PaywallTemplate,
} from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { HomeSource } from '@lmc/ts-common'
import { colours } from '@lmc/ui-kit/src/config/theme'

interface StateProps {
  subscribeTo: () => void
  getSubscriptions: () => void
  subscriptionCancelled?: boolean
  role?: string
  title?: string
  subTitle?: string
  source?: HomeSource
}

export const ProPaywallComponent: React.FC<StateProps> = ({
  subscribeTo,
  getSubscriptions,
  subscriptionCancelled,
  role,
  title,
  subTitle,
  source,
}) => {
  React.useEffect(() => {
    getSubscriptions()
  }, [])

  const ctaDisabled = role === 'senior-carer' || subscriptionCancelled
  let disabledText
  if (subscriptionCancelled) {
    disabledText = 'Note: Sorry, you have already completed a free trial.'
  } else if (role === 'senior-carer') {
    disabledText = 'Note: Only admins can start a free trial.'
  }

  const isSelfServe = source === 'Self-serve'

  return (
    <PaywallTemplate
      backgroundColor={colours.status.popout}
      title={title || 'Pro Plan'}
      subTitle={
        subTitle ||
        'Deliver and evidence people-centred care with helpful features such as care plans, risk assessments, consent management, handovers, photos, body maps and many more.'
      }
      bodyText={
        isSelfServe
          ? 'Start your 1 month free trial now.'
          : 'Interested in going pro?'
      }
      cta="Start Free Trial"
      onClick={subscribeTo}
      icon={IconType.ProHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'How do I get started with a Pro plan?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/collections/794905-getting-started',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'How much does it cost?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/1584269-how-much-does-it-cost',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What features are in the Pro plan?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      ctaDisabled={ctaDisabled}
      disabledText={disabledText}
      findOutMoreURL="https://logmycare.co.uk/pricing"
      source={source}
    />
  )
}

const mapStateToProps = (state: any) => ({
  subscriptionCancelled: Selectors.isSubscriptionCancelled(
    state,
    'pro-monthly'
  ),
  role: state.global?.user?.role,
  source: state.global?.home?.source,
})

const mapDispatchToProps = (dispatch: any) => ({
  subscribeTo: () =>
    dispatch(
      Operations.openNewPlan({
        planId: 'pro-monthly',
      })
    ),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
})

export const ProPaywall = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProPaywallComponent)
